/**
* Products - Show
*/
(function ($) {
  $(document).on('turbolinks:load', () => {
    // Only run this on `.products.show` page.
    if (!document.querySelector('.products.show')) {
      return
    }

    selectThumbnailOnHover()
  })

  /**
  * Overrides the default functionality where the user must click a thumbnail
  * image in order for it to be selected. Now when a user hovers over the
  * thumbnail it will be selected.
  *
  * See `frontend/product.js.coffee` for original functionality:
  * https://github.com/solidusio/solidus/blob/master/frontend/app/assets/javascripts/spree/frontend/product.js.coffee#L13
  */
  function selectThumbnailOnHover() {
    const $thumbnails = $('#product-images ul.thumbnails > li')


    const $mainImage = $('#main-image')

    $thumbnails.on('mouseenter', (e) => {
      const $thumbnail = $(event.currentTarget)

      $mainImage
        .data('selectedThumb', $thumbnail.find('a').attr('href'))
        .data('selectedThumbId', $thumbnail.parent().attr('id'))
      $thumbnails.removeClass('selected')
      $thumbnail.addClass('selected')
    })
  }
}(jQuery))
